export const onReconnect = () => {
    window.location.reload();
};
